import { render, staticRenderFns } from "./ChangeMemberRoleModal.vue?vue&type=template&id=522ebf76&"
import script from "./ChangeMemberRoleModal.vue?vue&type=script&lang=js&"
export * from "./ChangeMemberRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports